<template>
  <FilterAccordian title="Status" :selected="label(readFilterStatus)" class="mb-[12px]">
    <div
      v-for="status in statusOptions"
      :key="status.value"
      class="relative flex flex-row mb-[16px]"
    >
      <div @click="updateToggle(status.value)">
        <input :id="status.value" class="w-[20px] h-[20px]" type="radio" />
        <img
          v-if="status.isSelected"
          src="/assets/icons/calendar/radio-button-filled.svg"
          class="absolute top-[10px] left-0 w-[20px] h-[20px] transform -translate-y-1/2"
          alt=""
        />
        <img
          v-else
          src="/assets/icons/calendar/radio-button.svg"
          class="absolute top-[10px] left-0 w-[20px] h-[20px] transform -translate-y-1/2"
          alt=""
        />
      </div>
      <label
        :for="status.value"
        class="ml-2 font-normal text-[1rem] leading-[1.25rem] sm:text-[1.25rem] sm:leading-[1.5rem]"
      >
        {{ status.label }}
      </label>
    </div>
  </FilterAccordian>
</template>

<script>
import FilterAccordian from '@/components/Board/Filter/FilterAccordian';

export default {
  components: {
    FilterAccordian,
  },
  props: {
    isUnreadSelected: Boolean,
    isReadSelected: Boolean,
    isAllSelected: Boolean,
    readFilterStatus: String,
    updateToggle: Function,
  },
  computed: {
    statusOptions() {
      return [
        {
          value: 'all',
          label: 'All',
          isSelected: this.isAllSelected,
        },
        {
          value: 'read',
          label: 'Read',
          isSelected: this.isReadSelected,
        },
        {
          value: 'unread',
          label: 'Unread',
          isSelected: this.isUnreadSelected,
        },
      ];
    },
  },
  methods: {
    label(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
</script>
